import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document } from "@contentful/rich-text-types/dist/types/types";
import { useQuery } from "@tanstack/react-query";
import { createClient, EntryFieldTypes } from "contentful";

export type IReleaseNotes = {
  contentTypeId: "releaseNote";
  fields: {
    title: EntryFieldTypes.Text;
    introduction: EntryFieldTypes.RichText;
    heading1: EntryFieldTypes.Text;
    description1: EntryFieldTypes.RichText;
    image1: EntryFieldTypes.AssetLink;
    heading2?: EntryFieldTypes.Text;
    description2?: EntryFieldTypes.RichText;
    image2?: EntryFieldTypes.AssetLink;
    heading3?: EntryFieldTypes.Text;
    description3?: EntryFieldTypes.RichText;
    image3?: EntryFieldTypes.AssetLink;
    closing: EntryFieldTypes.RichText;
  };
};

export function useContentful() {
  const client = createClient({
    space: "vad47zc869sv",
    accessToken: "LgRvQ5XxidTkhai4knboE5faBu2JYgJOdaSKpZq4d-Q",
  });

  return client;
}

export function useGetLatestReleaseNotes() {
  const contentful = useContentful();

  return useQuery({
    queryKey: ["releaseNotes"],
    queryFn: () =>
      contentful.withoutUnresolvableLinks
        .getEntries<IReleaseNotes>({
          content_type: "releaseNote",
          include: 3,
          order: ["-sys.createdAt"],
        })
        .then((data) => data.items[0]),
  });
}

export function richTextToComponents(document: Document | undefined) {
  if (!document) return <></>;
  return documentToReactComponents(document);
}
